import React, { useState } from 'react';
import {
  Tooltip,
  TooltipTrigger,
  IconHelpCircle,
  ButtonIcon,
} from '@spotify-internal/encore-web';
import { IconProps } from '@spotify-internal/encore-web';
import { OverlayDirections } from '@spotify-internal/encore-web/types/src/core/styles';

type TooltipProps = {
  text: string;
  size: IconProps['iconSize'];
  placement?: OverlayDirections;
  maxWidth?: string;
};

export const HelpIconWithTooltip = ({
  text,
  size,
  placement,
  maxWidth,
}: TooltipProps) => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <>
      <TooltipTrigger
        overlay={
          showTooltip && (
            <Tooltip
              id="tooltip-content"
              {...(maxWidth ? { style: { maxWidth } } : {})}
            >
              {text}
            </Tooltip>
          )
        }
        placement={placement || TooltipTrigger.top}
        onShow={() => setShowTooltip(true)}
        onHide={() => setShowTooltip(false)}
      >
        <ButtonIcon aria-label="help">
          <IconHelpCircle iconSize={size} />
        </ButtonIcon>
      </TooltipTrigger>
    </>
  );
};
